'use client';

import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Flex, Spacing } from '@zoomit/primitives';

import { cssVar } from '../../css/css-var';
import { theme } from '../../theme';

type Props = {
  children?: ReactNode;
  className?: string;
};

export const ModalActions = (props: Props) => {
  const { children, className } = props;

  return (
    <Root gap={Spacing.x4} className={className} spacing={{ px: 'x6', py: 'x4' }}>
      {children}
    </Root>
  );
};

const Root = styled(Flex)`
  background-color: ${cssVar(theme.background1)};
  border-radius: 0 0 var(${theme.radius.sm}) var(${theme.radius.sm});
`;
